<div class="clearfix">
  <div class="row">
    <div [class.col-sm-2]="compact" [class.col-sm-3]="!compact">
      <nav>
        @if (label != null) {
        <h2>{{ label }}</h2>
        }
        <ul *ngSubscribe="visibleItems as visibleItems">
          @for (item of visibleItems; track item; let item_index = $index) {
          <li>
            <a
              routerLinkActive="active"
              [routerLink]="item.link"
              [queryParams]="item.queryParams"
              [routerLinkActiveOptions]="{ exact: item.exact }"
              matRipple
            >
              {{ item_index + 1 }}. {{ item.label }}
              <span>»</span>
              <div class="arrow-tip right"></div>
            </a>
          </li>
          }
        </ul>
        @if (additionalLabel != null && additionalVisibleItems != null) {
        <h2>{{ additionalLabel }}</h2>
        <ul *ngSubscribe="additionalVisibleItems as additionalVisibleItems">
          @for ( item of additionalVisibleItems; track item; let item_index =
          $index) {
          <li>
            <a
              routerLinkActive="active"
              [routerLink]="item.link"
              [queryParams]="item.queryParams"
              [routerLinkActiveOptions]="{ exact: item.exact }"
              matRipple
            >
              {{ item_index + 1 }}. {{ item.label }}
              <span>»</span>
              <div class="arrow-tip right"></div>
            </a>
          </li>
          }
        </ul>
        } @if (hasTodoList) {
        <todo-list [service]="service" [todos]="todos"></todo-list>
        }
      </nav>
    </div>

    <div
      [class.col-sm-10]="compact"
      [class.col-sm-9]="!compact"
      class="content"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
